import { render } from "./faqs.vue?vue&type=template&id=7132cbea"
import script from "./faqs.vue?vue&type=script&lang=js"
export * from "./faqs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__